var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('el-collapse',{on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('div',[_vm._v("No materials available")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }